import React from 'react';
import type { PageData } from './types';
import { OnboardingFlow } from '../athlete-onboarding/OnboardingFlow';

const INVITE_ERROR_MESSAGES: Record<string, string> = {
    not_found: 'This invite link is invalid or no longer exists.',
    expired: 'This invite link has expired.',
    max_uses_exceeded: 'This invite link has reached its maximum number of uses.',
    error: 'Something went wrong loading your invite. Please try again.',
};

export function App(props: PageData) {
    if (props.inviteError) {
        return (
            <div className="ob">
                <div className="ob__backdrop ob__backdrop--centered">
                    <div className="ob__modal ob__modal--error">
                        <div className="ob-step">
                            <div className="ob-step__head">
                                <h2 className="ob-step__title">Unable to Join</h2>
                                <p className="ob-step__desc">{INVITE_ERROR_MESSAGES[props.inviteError]}</p>
                            </div>
                            <a className="ob-continue" href="/">Return to Faves</a>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <OnboardingFlow
            activationToken={props.activationToken}
            brandInvitation={props.brandInvitation}
            csrfToken={props.csrfToken}
            formConfig={props.formConfig}
            igRequired={props.igRequired}
            introSlides={props.introSlides}
            inviteId={props.inviteId}
            mode={props.mode ?? 'creation'}
            prefill={props.prefill}
            seedingBrandId={props.seedingBrandId}
            stepBackgrounds={props.stepBackgrounds}
            supportedActivities={props.supportedActivities}
        />
    );
}
